import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import "@/lib/pwa";

// Silence benign "ResizeObserver loop" warning that triggers the CRA dev error overlay
// (harmless; commonly fired by Recharts ResponsiveContainer on first mount).
const _roMsg = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message && e.message.includes(_roMsg)) { e.stopImmediatePropagation(); }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
